<template>
  <div id="ui-view">
    <div>
      <div class="card">
        <div class="card-header">
          <strong><img :src="company_logo" style="height: 35px;" /></strong>
          <a
            href="#"
            class="btn btn-sm btn-info float-right printpage"
            onclick="javascript:window.print();"
            style="margin-top: 10px;"
          >
            <i class="fa fa-print"></i> Print</a
          >
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-2 card-header"></div>
            <div class="col-md-8">
              <div class="row">
                <div class="col-md-8">
                  <div>
                    <strong>{{ shop.name }}</strong>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      {{ shop.add1 }} {{ shop.add2 }} {{ shop.city }}
                      <span v-if="shop.pincode != null"
                        >- {{ shop.pincode }}</span
                      >
                      {{ shop.state }} - {{ shop.country }}
                      <span v-if="shop.gst != null">GSTIN : {{ shop.gst }}</span
                      ><span v-if="shop.phone != null">
                        Contact : {{ shop.phone }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="invoice" style="font-size: 40px;">
                    Tax Invoice
                  </div>
                </div>
              </div>

              <div class="row mbt-4">
                <div class="col-sm-4">
                  <h6 class="my-3">Bill To:</h6>
                  <div>
                    <strong>{{ cust_name }}</strong>
                  </div>
                  <div>{{ customer.add1 }} {{ customer.add2 }}</div>
                  <div>
                    {{ customer.city }} {{ customer.state }}
                    <span v-if="customer.pincode != ''"></span>
                    {{ customer.pincode
                    }}<span v-if="customer.country != ''"></span>
                    {{ customer.country }}
                  </div>
                  <div v-if="customer.email != ''">Email: {{ cust_email }}</div>
                  <div v-if="customer.phone != ''">Phone: {{ cust_phone }}</div>
                </div>

                <div class="col-sm-4">
                  <h6 class="my-3">
                    Ship To:
                    <!-- <small class="printpage"><i class="fa fa-edit" @click.prevent="addressModel =true"></i></small> -->
                  </h6>
                  <div>
                    <strong
                      >{{ customer1.name }} &nbsp; {{ customer1.phone }}</strong
                    >
                  </div>
                  <div>{{ customer1.add }}</div>
                  <div>
                    {{ customer1.city }} {{ customer1.state }}
                    {{ customer1.pincode }}
                  </div>
                </div>

                <div class="col-sm-4">
                  <h6 class="my-3">Details:</h6>
                  <div>
                    Invoice
                    <strong>#{{ sales.id }}</strong>
                  </div>
                  <div>Invoice Date : {{ sales.date }}</div>
                  <div v-if="cmp.cmp_bnk_holder != null">
                    Account Name: {{ cmp.cmp_bnk_holder }}
                  </div>
                  <div v-if="cmp.cmp_swift != null">
                    <strong>SWIFT Code: {{ cmp.cmp_swift }}</strong>
                  </div>
                </div>
              </div>

              <div
                class="card-header"
                style="padding-top: 0px; padding-bottom: 0px;"
              >
                <h4>
                  Attn: <span>{{ cust_name }}</span>
                </h4>
              </div>

              <div class="table-responsive-sm">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="center">#</th>
                      <th>Item & Description</th>
                      <th class="center">Quantity</th>
                      <th class="right">Sale Price</th>
                      <th class="right">Amount Before Tax</th>
                      <th class="right">Discount</th>
                      <th class="right">SGST %</th>
                      <th class="right">CGST %</th>
                      <th class="right">IGST %</th>
                      <th class="right">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rows">
                      <td class="center">{{ index + 1 }}</td>
                      <td class="left">
                        {{ row.product_name }} ({{ row.variant_id }})
                      </td>
                      <td class="left">{{ row.sale_qty }}</td>
                      <td class="center">
                        ₹{{ formatAmt(row.product_unit_cost) }}
                      </td>
                      <td class="right">₹{{ formatAmt(row.sub_total) }}</td>
                      <td class="right">
                        <span v-if="row.sale_igst != ''"
                          >₹{{ formatAmt(row.item_discount) }}</span
                        >
                      </td>
                      <td class="right">
                        <span v-if="row.sale_cgst != ''"
                          >{{ formatAmt(row.sale_cgst) }}%</span
                        >
                      </td>
                      <td class="right">
                        <span v-if="row.sale_sgst != ''"
                          >{{ formatAmt(row.sale_sgst) }}%</span
                        >
                      </td>
                      <td class="right">
                        <span v-if="row.sale_igst != ''"
                          >{{ formatAmt(row.sale_igst) }}%</span
                        >
                      </td>
                      <td class="right">{{ formatAmt(row.amt_to_pay) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="row">
                <div class="col-lg-4 col-sm-5" style="margin-top: 10px;">
                  Total in words:<br /><strong>{{ amt_word }}</strong>
                  <div
                    class="col-md-12"
                    style="
                      text-align: rigth;
                      padding-left: 0px;
                      padding-top: 122px;
                    "
                  >
                    Authorized Signature
                  </div>
                </div>
                <div class="col-lg-4 col-sm-5 ml-auto">
                  <table class="table table-clear">
                    <tbody>
                      <tr>
                        <td class="left">
                          <strong>Total</strong>
                        </td>
                        <td class="right">
                          ₹ {{ sales.total_amt_before_disc }}
                        </td>
                      </tr>
                      <tr>
                        <td class="left">
                          <strong>Discount</strong>
                        </td>
                        <td class="right">₹ {{ sales.total_discount }}</td>
                      </tr>
                      <tr>
                        <td class="left">
                          <strong>CGST</strong>
                        </td>
                        <td class="right">₹ {{ sales.cgst }}</td>
                      </tr>
                      <tr>
                        <td class="left">
                          <strong>SGST</strong>
                        </td>
                        <td class="right">₹ {{ sales.sgst }}</td>
                      </tr>
                      <tr>
                        <td class="left">
                          <strong>IGST</strong>
                        </td>
                        <td class="right">₹ {{ sales.igst }}</td>
                      </tr>
                      <tr>
                        <td class="left">
                          <strong>Total</strong>
                        </td>
                        <td class="right">
                          <strong>{{ sales.total_amt_pay }}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td class="left">
                          <strong>Amount Paid</strong>
                        </td>
                        <td class="right">
                          <strong>{{ sales.total_amt_paid }}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td class="left">
                          <strong>Balance</strong>
                        </td>
                        <td class="right">
                          <strong>{{ sales.balance }}</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-2 card-header"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <b-modal title="Shipping Details" hide-footer size="lg" v-model="addressModel" @ok="addressModel = false">
       <div class="row" v-for="(address1, index) in addr">
        <div class="col-sm-10">
          <div class="form-group">
            <b>{{address1.yname}}&nbsp;({{address1.yphn}})</b><br>
            <span v-if="address1.yaddress!=''">
             {{address1.yaddress}}<br></span>
             <span v-if="address1.ystate != '' && address1.ycity != '' && address1.ypincode != ''">
               {{address1.ystate}} &nbsp; {{address1.ycity}} - {{address1.ypincode}}
             </span>
           </div> 
         </div>

         <div class="col-sm-2" style="color:#f86c6b;font-size: 20px; cursor: pointer;">
          <span>
           <small> <i @click="showAddress(address1)" class="fa fa-plus" style="color:#34a8d8;cursor:pointer;">Add</i></small>
         </span> 
       </div><hr width="97%">
     </div>            
   </b-modal> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      access_token: null,
      rows: [],
      company_logo: "",
      addressModel: false,
      cust_name: "",
      cust_email: "",
      cust_phone: "",
      cust_country: "",
      cust_state: "",
      cust_city: "",
      total_in_words: "",
      shop: {
        name: null,
        add1: null,
        add2: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        gst: null,
        phone: null,
      },
      customer1: {
        ship_id: null,
        name: null,
        add: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        phone: null,
      },
      customer: {
        name: null,
        add1: null,
        add2: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        phone: null,
        email: null,
        gst: null,
        pan: null,
        cin: null,
        tan: null,
        cust_name: null,
        cust_email: null,
        cust_phone: null,
        cust_country: null,
        cust_city: null,
        cust_state: null,
      },
      sales: {
        id: null,
        total_amt_pay: null,
        total_items_disc: null,
        additional_discount: null,
        total_amt_before_disc: null,
        cgst: null,
        sgst: null,
        igst: null,
        date: null,
        total_discount: "0.00",
        total_amt_paid: null,
        balance: null,
      },
      addr: [],
      cmp: {
        cmp_swift: null,
        cmp_bnk_holder: null,
      },
      amt_word: null,
      total_in_words: "",
    };
  },
  created() {
    var _this = this;
    var timer = setInterval(function () {
      if ("cid" in _this.$route.query && "sid" in _this.$route.query) {
        clearInterval(timer);
        var cid = _this.$route.query.cid;
        var sid = _this.$route.query.sid;
        _this.loadData(cid, sid);
      }
    }, 600);
  },
  methods: {
    loadData(cid, sid) {
      // if(localStorage.authUser != null){
      //   this.access_token = '?access_token='+localStorage.authUser
      // }
      this.customer_id = cid;
      this.shopuser();
      var data = [];
      var _this = this;

      this.$http
        .get("/api/companydetails/findOne")
        .then(function (response) {
          if (response.data.cmp_logo == null || response.data.cmp_logo == "") {
            _this.company_logo = "";
          } else {
            _this.company_logo =
              _this.$http.defaults.baseURL +
              "/api/containers/pics/download/" +
              response.data.cmp_logo +
              _this.access_token;
          }
        })
        .catch(function (error) {});
      this.$http
        .get(
          "/api/customershippspecs?filter[where][customer_id]=" +
            this.customer_id
        )
        .then(function (response) {
          var addr_data = response.data["ship_dt"];
          var state_dt = response.data["state_dt"];
          var city_dt = response.data["city_dt"];
          // var addr_data = response.data
          for (var i = 0; i < addr_data.length; i++) {
            _this.addr.push({
              yname: addr_data[i].customer_name,
              yaddress: addr_data[i].address,
              ypincode: addr_data[i].pincode,
              ystate: state_dt[addr_data[i].state_code],
              ystateid: addr_data[i].state_code,
              ycityid: addr_data[i].city,
              ycity: city_dt[addr_data[i].city],
              yphn: addr_data[i].contact_no,
              chkship_id: addr_data[i].shipp_id,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      //if(this.$router.query != undefined){
      var _this = this;
      var data = {};
      // Todays Date Start

      // Todays Date Ends

      // data.saleid = this.$router.props[0]
      // data.customer_id = this.$router.props[1]
      data.saleid = sid;
      data.customer_id = cid;
      this.$http
        .post("/api/saledetails/generate_invoice", data)
        .then(function (response) {
          _this.rows = response.data;
          // console.log("<br>")
          // console.log(response.data)
          // console.log("----------------------")
          for (var i = 0; i < _this.rows.length; i++) {
            _this.rows[i]["item_discount"] = 0.0;
            if (
              _this.rows[i]["disc_pct"] !== "" &&
              _this.rows[i]["disc_pct"] !== null &&
              _this.rows[i]["disc_pct"] !== undefined &&
              _this.rows[i]["disc_pct"] !== "0.000000"
            ) {
              // console.log( _this.rows[i]['disc_pct'])
              _this.rows[i]["item_discount"] =
                (parseInt(_this.rows[i]["disc_pct"]) / 100) *
                (parseFloat(_this.rows[i]["sale_qty"]) *
                  parseFloat(_this.rows[i]["product_unit_cost"]));
            }

            if (
              _this.rows[i]["disc_amt"] !== "" &&
              _this.rows[i]["disc_amt"] !== null &&
              _this.rows[i]["disc_amt"] !== undefined &&
              _this.rows[i]["disc_amt"] !== "0.000000"
            ) {
              // console.log( _this.rows[i]['disc_amt'])
              _this.rows[i]["item_discount"] = parseFloat(
                _this.rows[i]["disc_amt"]
              );
            }
          }

          if (response.data[0] != undefined) {
            // Company Details
            var total_item_disc = 0.0;
            var additional_discount = 0.0;
            var total_paid = 0.0;
            _this.cmp.cmp_swift = response.data[0].cmp_swift;
            _this.cmp.cmp_bnk_holder = response.data[0].cmp_bnk_holder;
            _this.cust_name = response.data[0].cust_cmp_name;
            _this.cust_email = response.data[0].cus_email;
            _this.cust_phone = response.data[0].cus_phone;
            _this.word(response.data[0].total_amt_pay);
            _this.customer.city = response.data[0].cus_city;
            _this.customer.state = response.data[0].cus_state;
            _this.customer.country = response.data[0].cus_cnty;
            _this.customer.pincode = response.data[0].cus_pincode;
            _this.customer.add1 = response.data[0].cus_add1;
            _this.customer.add2 = response.data[0].cus_add2;
            _this.customer.gst = response.data[0].cus_gst;
            _this.customer.pan = response.data[0].cus_pan;
            _this.customer.cin = response.data[0].cus_cin;
            _this.customer.tan = response.data[0].cus_tan;
            _this.customer1.ship_id = response.data[0].ship_id;
            _this.customer1.country = response.data[0].ship_country;
            _this.customer1.name = response.data[0].ship_customer_name;
            _this.customer1.add = response.data[0].ship_address;
            _this.customer1.city = response.data[0].ship_city;
            _this.customer1.state = response.data[0].ship_state;
            _this.customer1.pincode = response.data[0].ship_pincode;
            _this.customer1.phone = response.data[0].ship_contact_no;

            // Sales Details
            _this.sales.id = response.data[0].sales_id;
            _this.sales.total_amt_pay = parseFloat(
              response.data[0].total_amt_pay
            ).toFixed(2);
            total_item_disc = parseFloat(response.data[0].total_items_disc);
            _this.sales.total_items_disc = parseFloat(
              response.data[0].total_items_disc
            ).toFixed(2);
            _this.sales.cgst = parseFloat(response.data[0].cgst_amt).toFixed(2);
            _this.sales.sgst = parseFloat(response.data[0].sgst_amt).toFixed(2);
            _this.sales.igst = parseFloat(response.data[0].igst_amt).toFixed(2);
            _this.sales.total_amt_before_disc = parseFloat(
              response.data[0].total_amt_before_disc
            ).toFixed(2);
            additional_discount = parseFloat(
              response.data[0].additional_discount
            );
            _this.sales.additional_discount = parseFloat(
              response.data[0].additional_discount
            ).toFixed(2);
            _this.sales.total_discount = parseFloat(
              total_item_disc + additional_discount
            ).toFixed(2);

            total_paid =
              parseFloat(response.data[0].total_amt_pay) -
              parseFloat(response.data[0].total_amt_pendingpay);
            _this.sales.total_amt_paid = parseFloat(total_paid).toFixed(2);
            _this.sales.balance = parseFloat(
              response.data[0].total_amt_pendingpay
            ).toFixed(2);

            var today = new Date(response.data[0].sale_entry_date);
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();
            if (dd < 10) {
              dd = "0" + dd;
            }
            if (mm < 10) {
              mm = "0" + mm;
            }
            today = dd + "/" + mm + "/" + yyyy;
            _this.sales.date = today;
            // Shop Details
            _this.shop.name = response.data[0].shp_name;
            _this.shop.add1 = response.data[0].shp_add1;
            _this.shop.add2 = response.data[0].shp_add2;
            _this.shop.city = response.data[0].shp_city;
            _this.shop.state = response.data[0].shp_state;
            _this.shop.country = response.data[0].shp_cnty;
            _this.shop.pincode = response.data[0].shp_pin;
            _this.shop.gst = response.data[0]._this.shop.phone =
              response.data[0].shp_phone;

            // Customer Details
            _this.customer.name = response.data[0].cust_cmp_name;
            _this.customer.add1 = response.data[0].cus_add1;
            _this.customer.add2 = response.data[0].cus_add2;
            _this.customer.city = response.data[0].cus_city;
            _this.customer.state = response.data[0].cus_state;
            _this.customer.country = response.data[0].cus_cnty;
            _this.customer.pincode = response.data[0].cus_pincode;
            _this.customer.phone = response.data[0].cus_phone;
            _this.customer.email = response.data[0].cus_email;
            _this.customer.gst = response.data[0].cus_gst;
            _this.customer.pan = response.data[0].cus_pan;
            _this.customer.cin = response.data[0].cus_cin;
            _this.customer.tan = response.data[0].cus_tan;
            _this.word(response.data[0].total_amt_pay);
            _this.customer1.name = response.data[0].cust_cmp_name;
            _this.customer1.add = response.data[0].cus_add1;
            _this.customer1.city = response.data[0].cus_city;
            _this.customer1.state = response.data[0].cus_state;
            _this.customer1.pincode = response.data[0].cus_pincode;
            _this.customer1.phone = response.data[0].cus_phone;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      //}
    },

    shopuser() {
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {})
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },

    formatAmt(value) {
      return parseFloat(value).toFixed(2);
    },
    showAddress(adrs) {
      this.customer1.name = adrs.yname;
      this.customer1.add = adrs.yaddress;
      this.customer1.city = adrs.ycity;
      this.customer1.phone = adrs.yphn;
      this.customer1.state = adrs.ystate;
      this.customer1.pincode = adrs.ypincode;
      this.addressModel = false;
    },
    word(amt) {
      // console.log("AMT IN WORDS")
      // console.log(amt)
      var _this = this;
      var string = _this.inWords(parseInt(amt));
      _this.amt_word = string;
      // console.log(_this.amt_word)
    },

    inWords(num) {
      var a = [
        "",
        "One ",
        "Two ",
        "Three ",
        "Four ",
        "Five ",
        "Six ",
        "Seven ",
        "Eight ",
        "Nine ",
        "Ten ",
        "Eleven ",
        "Twelve ",
        "Thirteen ",
        "Fourteen ",
        "Fifteen ",
        "Sixteen ",
        "Seventeen ",
        "Eighteen ",
        "Nineteen ",
      ];
      var b = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];

      if ((num = num.toString()).length > 9) return "overflow";
      var n = ("000000000" + num)
        .substr(-9)
        .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
      if (!n) return;
      var str = "";
      str +=
        n[1] != 0
          ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "Crore "
          : "";
      str +=
        n[2] != 0
          ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "Lakh "
          : "";
      str +=
        n[3] != 0
          ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "Thousand "
          : "";
      str +=
        n[4] != 0
          ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "Hundred "
          : "";
      str +=
        n[5] != 0
          ? (str != "" ? "and " : "") +
            (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
            "Only "
          : "";
      return str;
    },
  },
};
</script>

<style type="text/css">
.editpencial {
  display: none !important;
}

.my-3 {
  padding-top: 5px !important;
}
.mbt-4 {
  margin-top: 15px !important;
}

@media print {
  .breadcrumb {
    display: none;
  }
  .printpage {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/sales/salepdf.vue